import { useState, useEffect, useRef } from 'react'
import { X, AlertCircle } from 'lucide-react'
import { Portal } from '@/shared/components/ui/Portal'
import styles from './SurvivorSheets.module.css'

type Props = { onClose: () => void }

type NotifToggle = { id: string; label: string; description: string; defaultOn: boolean }

const NOTIFICATIONS: NotifToggle[] = [
  { id: 'pick_reminder', label: 'Lembrete de escolha', description: 'Aviso quando faltar pouco para a rodada fechar e você ainda não escolheu.', defaultOn: true },
  { id: 'pick_result',   label: 'Resultado da rodada', description: 'Se você sobreviveu ou foi eliminado após cada rodada.',                    defaultOn: true },
  { id: 'game_finished', label: 'Fim do jogo',          description: 'Quando o jogo termina e há um campeão.',                                  defaultOn: true },
]

export function SurvivorNotificationsSheet({ onClose }: Props) {
  const sheetRef = useRef<HTMLDivElement>(null)

  const [toggles, setToggles] = useState<Record<string, boolean>>(
    Object.fromEntries(NOTIFICATIONS.map((n) => [n.id, n.defaultOn])),
  )

  useEffect(() => {
    function handleKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', handleKey)
    return () => document.removeEventListener('keydown', handleKey)
  }, [onClose])

  useEffect(() => {
    sheetRef.current?.focus()
  }, [])

  function toggle(id: string) {
    setToggles((prev) => ({ ...prev, [id]: !prev[id] }))
  }

  return (
    <Portal>
      <div className={styles.backdrop} onClick={onClose} role="dialog" aria-modal="true" aria-label="Notificações do jogo">
        <div ref={sheetRef} className={styles.sheet} onClick={(e) => e.stopPropagation()} tabIndex={-1}>
          <div className={styles.header}>
            <span className={styles.title}>Notificações</span>
            <button className={styles.closeBtn} onClick={onClose} aria-label="Fechar">
              <X size={16} />
            </button>
          </div>

          <div className={styles.body}>
            <div className={styles.globalWarning}>
              <AlertCircle size={14} />
              <p>Notificações push requerem permissão do navegador.</p>
            </div>

            <div className={styles.group}>
              {NOTIFICATIONS.map((item) => (
                <label key={item.id} className={styles.notifRow}>
                  <div className={styles.notifInfo}>
                    <span className={styles.notifLabel}>{item.label}</span>
                    <span className={styles.notifDesc}>{item.description}</span>
                  </div>
                  <button
                    role="switch"
                    aria-checked={toggles[item.id]}
                    className={styles.toggle}
                    data-on={toggles[item.id]}
                    onClick={() => toggle(item.id)}
                    aria-label={item.label}
                  >
                    <span className={styles.toggleThumb} />
                  </button>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Portal>
  )
}
